
define(
	'Tavanoteam.CustomerEventRegistration.CustomerEventRegistration'
,   [
		'Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.View',
		'Tavanoteam.CustomerEventRegistration.CustomerEventConfirmation.View',
		'Tavanoteam.CustomerEventRegistration.CustomerEventRegistration.ValidationMessage.View'
	]
,   function (
		CustomerEventRegistrationView,
		CustomerEventConfirmationView,
		CustomerEventRegistrationValidationMessageView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var pageType = container.getComponent('PageType');
			
			if(layout)
			{

				//Create Event Registration Page
		
				var registrationPage = {
					name: 'customer_event_registration_page',
					routes: ['event-registration'],
					view: CustomerEventRegistrationView,
					options: { container: container },
					defaultTemplate: {
						name: 'tavanoteam_customereventregistration_customereventregistration.tpl',
						displayName: 'Event Registration'
					}
				}
				pageType.registerPageType(registrationPage);

				//Create Event Confirmation Page
				
				var confirmationPage = {
					name: 'customer_event_confirmation_page',
					routes: ['event-registration-confirmation'],
					view: CustomerEventConfirmationView,
					options: { container: container },
					defaultTemplate: {
						name: 'tavanoteam_customereventregistration_customereventconfirmation.tpl',
						displayName: 'Event Registration Confirmation'
					}
				}
				pageType.registerPageType(confirmationPage);

			}

		}
	};
});
